import { GoogleLogo, TrustpilotLogo, TrustedShopsLogo } from 'assets';
import { funnel } from 'data';
import { Flex } from 'mymoria-ui/components';
import { FlexboxProps, LayoutProps, SpaceProps } from 'mymoria-ui/interfaces';
import { styled } from 'mymoria-ui/utils';
import { FunctionComponent } from 'react';
import Rating from './Rating';

const { partners } = funnel.contactDetails;

export interface PartnersProps extends FlexboxProps, SpaceProps, LayoutProps {
  className?: string;
}

const StyledImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
`;

const Partners: FunctionComponent<PartnersProps> = ({ className, ...props }) => (
  <Flex className={className} flexWrap="wrap" justifyContent="center" {...props}>
    <Flex justifyContent="center" pb="medium">
      <StyledImage alt="Google" src={GoogleLogo} />
      <Rating rating={partners.google.rating} caption={partners.google.caption} mr="large" />
    </Flex>
    <Flex justifyContent="center" pb="medium">
      <StyledImage alt="Trusted Shops" src={TrustedShopsLogo} />
      <Rating
        rating={partners.trustedShops.rating}
        caption={partners.trustedShops.caption}
        mr="large"
      />
    </Flex>
    <Flex justifyContent="center" pb="medium">
      <StyledImage alt="Trustpilot" src={TrustpilotLogo} />
      <Rating
        rating={partners.trustpilot.rating}
        caption={partners.trustpilot.caption}
        mr="large"
      />
    </Flex>
  </Flex>
);

export default Partners;
